import { MemberCryptoFromSecretKey } from './member-crypto-from-secret-key';
export class MemberCryptoFromInvitationSecret extends MemberCryptoFromSecretKey {
    secretKey;
    constructor(member, invitationSecret, logger) {
        super(member, logger);
        this.secretKey = invitationSecret;
    }
    getEncryptedInvitationKey() {
        return this.member.invitation.ePrivateKeyByInvitationSecret;
    }
}
